module.exports = __webpack_public_path__ + "static/img/visa.7a1e3689.svg";